import Modal from "../Modal/Modal";
import Button, { ButtonType } from "../Button/Button";
import EmailTransferInfo from "./EmailTransferInfo";

interface IProps {
  onCloseModal?: () => void;
  closeButtonName?: string;
}

const EmailTransferInfoModal = (props: IProps) => {
  const { onCloseModal, closeButtonName = "Close" } = props;
  return (
    <Modal>
      <div className="bank-transfer-info-modal">
        <EmailTransferInfo />
        <div className="actions">
          {onCloseModal && (
            <Button type={ButtonType.secondary} onClick={onCloseModal}>
              {closeButtonName}
            </Button>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default EmailTransferInfoModal;
